import Affix from './src/affix';

module.exports = Affix;


// WEBPACK FOOTER //
// ./src/components/affix/index.js